import { SWRFetcher } from '@commenda/utils';
import { CompanyHandlerType } from '@prisma/client';
import useSWR from 'swr';

export type TCompanyHandler = {
  id: string;
  name: string;
  email: string;
  image?: string;
  meetingCalendarLink?: string;
  type: CompanyHandlerType;
  role: string;
  additionalInfo?: string;
  createdAt: string | Date;
  lastUpdatedAt: string | Date;
};

export type TCompanyHandlersResponse = {
  handlers: TCompanyHandler[];
  count: number;
};

export enum CompanyHandlerGetExtensibleFields {
  RELATIONS = 'RELATIONS',
}

export interface GetCompanyHandlerParams {
  companyIds?: number[];
  type?: CompanyHandlerType;
  extends?: CompanyHandlerGetExtensibleFields[];
}

const useGetCompanyHandler = (params: GetCompanyHandlerParams | null = {}) => {
  const { companyIds, type, extends: extendsFields } = params || {};

  // Build query string
  const queryParams = new URLSearchParams();

  if (companyIds && companyIds.length > 0) {
    queryParams.append('companyIds', companyIds.join(','));
  }

  if (type) {
    queryParams.append('type', type);
  }

  if (extendsFields && extendsFields.length > 0) {
    extendsFields.forEach((field) => queryParams.append('extends', field));
  }

  const queryString = queryParams.toString();
  const requestURL = queryString
    ? `company-handlers?${queryString}`
    : 'company-handlers';

  const { data, error, isLoading, mutate } = useSWR(
    params ? requestURL : null,
    SWRFetcher({ method: 'GET' })
  );

  return {
    data: data as TCompanyHandlersResponse | undefined,
    error,
    isLoading,
    mutate,
  };
};

export default useGetCompanyHandler;
